
































import {Component, Mixins} from 'vue-property-decorator'
import {Getter} from 'vuex-class'
import {$, PageCollection, pushByName, success} from 'simpli-web-sdk'
import {MixinFilter} from '@/components/mixins/MixinFilter'
import {MixinSelect} from '@/components/mixins/MixinSelect'
import {AppConfig} from '@/config/app.config'
import Responsavel from '@/model/resource/Responsavel'
import OcultarNotasResponsavel from '@/model/resource/OcultarNotasResponsavel'

const metaInfo = () => ({
  title: $.t('view.manage.hideResponsavelNotas.title'),
})

@Component({
  metaInfo,
})
export default class ManageAlertTypeListView extends Mixins(MixinFilter, MixinSelect) {
  @Getter('auth/responsavel') user!: Responsavel

  AppConfig = AppConfig
  pushByName = pushByName

  collection = new PageCollection(OcultarNotasResponsavel, {}, 10)

}
